// extracted by mini-css-extract-plugin
var _1 = "BirdviewCard-moduleai__QbHg3";
var _2 = "BirdviewCard-modulecard__T2Gum";
var _3 = "BirdviewCard-modulecontrols__e6LN3";
var _4 = "BirdviewCard-modulefooter__Lx9gi";
export { _1 as "ai", _2 as "card", _3 as "controls", _4 as "footer" }
